exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".OpenTicketClaimCard-defaultContent-3v3PU h5{text-transform:none}.OpenTicketClaimCard-defaultContent-3v3PU label small{display:block;margin-left:34px;font-size:14px;font-weight:300}.OpenTicketClaimCard-externaCallDateTimePicker-2gnt5{margin-top:10px;text-align:center}.OpenTicketClaimCard-externaCallDateTimePicker-2gnt5 .OpenTicketClaimCard-container-1X1ku{display:inline-block}", ""]);

// exports
exports.locals = {
	"defaultContent": "OpenTicketClaimCard-defaultContent-3v3PU",
	"externaCallDateTimePicker": "OpenTicketClaimCard-externaCallDateTimePicker-2gnt5",
	"container": "OpenTicketClaimCard-container-1X1ku"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?localIdentName=[name]-[local]-[hash:base64:5]!./~/autoprefixer-loader!./~/less-loader!./lib/claim/components/OpenTicketClaimCard.less
// module id = 1604
// module chunks = 0